import type { NavigationProp, ParamListBase } from "@react-navigation/core";
import React, { FC, useEffect, useRef, useState } from "react";
import { ScrollView, StyleSheet, Text, TextInput, View } from "react-native";
import { useSelector } from "react-redux";
import RecentSearches from "src/components/RecentSearches";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { setBackButtonRoute } from "src/redux/navigation/thunkActions";
import { saveRecentSearch, useSearchHook } from "src/util/search";
import { Pagination, Table } from "../components";

const P07_CommissionLog: FC<{ navigation: NavigationProp<ParamListBase> }> = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setBackButtonRoute(undefined));
  }, [dispatch]);
  const [_sRenderSearches, setRenderSearches] = useState<boolean>(false);
  const rSearchData = useSelector(({ SearchReducer }) => SearchReducer.rSearchData);
  const kTableData = [
    ["03/09/2021", "B756", "$2000", "$200", "", "", "$200", "View Details"],
    ["03/08/2021", "B755", "$3000", "$300", "", "", "$300", "View Details"],
    ["03/07/2021", "B754", "$1500", "$150", "", "", "$150", "View Details"],
    ["03/06/2021", "B753", "$1000", "$100", "", "", "$100", "View Details"],
    ["03/05/2021", "B752", "$3500", "$350", "", "", "$350", "View Details"],
  ];

  const aTableRef = useRef(kTableData);
  useSearchHook(kTableData, aTableRef, rSearchData?.commissionData?.currentSearch);

  return (
    <>
      <View>
        <TextInput
          value={rSearchData?.commissionData?.currentSearch ?? ""}
          placeholder="Search Transactions"
          style={styles.commissionTextInput}
          onFocus={() => setRenderSearches(true)}
          onBlur={() => {
            setRenderSearches(false);
            dispatch({
              type: "UPDATE_SEARCH",
              rSearchData: {
                ...rSearchData,
                commissionData: {
                  ...rSearchData?.commissionData,
                  recentSearches: saveRecentSearch(
                    rSearchData?.commissionData?.currentSearch,
                    rSearchData?.commissionData?.recentSearches,
                  ),
                },
              },
            });
          }}
          onChangeText={(text) => {
            dispatch({
              type: "UPDATE_SEARCH",
              rSearchData: {
                ...rSearchData,
                commissionData: { ...rSearchData.commissionData, currentSearch: text.toLowerCase() },
              },
            });
          }}
        />
        <RecentSearches myRecentSearches={rSearchData?.commissionData?.recentSearches} myRenderSearches={true} />
      </View>
      <ScrollView style={styles.gStackScreenDefault}>
        <View style={styles.gTablePageContainer}>
          <Text style={styles.sectionTitle}>Transaction Log</Text>

          <Table
            headerData={[
              "Update Date",
              "Order No.",
              "Order Amount",
              "Commission Due",
              "Discount",
              "Paid",
              "Balance",
              "Action",
            ]}
            tableData={aTableRef.current}
            keys={aTableRef.current.map((myTableRow) => myTableRow[1])}
          />

          <Pagination pages={10} currentPage={1} onSelect={() => true} />
        </View>
      </ScrollView>
    </>
  );
};

export const P07 = React.memo(P07_CommissionLog);

const styles = StyleSheet.create({
  commissionTextInput: { height: 30, width: 300 },
  gStackScreenDefault: {
    backgroundColor: kColors.white,
    flex: 1,
  },
  gTablePageContainer: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    marginBottom: 30 * kStyleConst.kSpacing,
    marginHorizontal: 9 * kStyleConst.kSpacing,
    marginTop: 11 * kStyleConst.kSpacing,
  },
  sectionTitle: {
    alignSelf: "flex-start",
    fontSize: 22,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
});
